import EmailView from "../email/emailView";
import EmailEdit from "../email/emailEdit";
import React from "react";
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";

class EmailToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggleEditMode: false, success: false, emailMessage: "" };
    this.toggleMode = this.toggleMode.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.emailData = this.emailData.bind(this);
  }
  toggleMode(val) {
    this.setState({ toggleEditMode: val });
  }
  showSuccess(val) {
    this.setState({ success: val });
    setTimeout(() => {
      this.setState({ success: false });
    }, 10000);
  }
  emailData(val) {
    this.setState({ emailMessage: val });
  }
  render() {
    const message = this.props.message;
    const accessSpecifier = this.props.accessSpecifier;
    return (
      <>
        {this.state.toggleEditMode ? (
          <EmailEdit
            message={message}
            toggleMode={this.toggleMode}
            success={this.showSuccess}
            emailData={this.state.emailMessage}
          />
        ) : (
          <EmailView
            message={message}
            toggleMode={this.toggleMode}
            isSuccess={this.state.success}
            accessSpecifier={accessSpecifier}
            emailData={this.emailData}
          />
        )}
      </>
    );
  }
}

export default EmailToggle;
